<template>
  <div class="chat-tab">
    <chat-header
      :show-close-button="showCloseButton"
      @close="$emit('toggle-chat')"
    />
    <chat-body />
    <div class="chat-tab__input">
      <chat-input v-if="isTypingEnabled" />
    </div>
    <transition name="fade">
      <notification v-if="isShowingLeadsToNoRecommendation" @close="onCloseNotification">
        <leads-to-no-recommendation-message />
      </notification>
    </transition>
  </div>
</template>

<script>
// @flow

import { mapActions, mapGetters } from 'vuex'

import { ChatHeader, ChatBody, ChatInput } from '../../'
import LeadsToNoRecommendationMessage from '../../LeadsToNoRecommendationMessage/LeadsToNoRecommendationMessage.vue'
import Notification from '../../Notification/Notification.vue'

export default {
  components: {
    ChatHeader,
    ChatBody,
    ChatInput,
    Notification,
    LeadsToNoRecommendationMessage
  },
  props: {
    showCloseButton: {
      default: true,
      type: Boolean
    },
    isTypingEnabled: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(['isShowingLeadsToNoRecommendation'])
  },
  methods: {
    ...mapActions(['toggleNotification']),
    onCloseNotification (): void {
      this.toggleNotification('leadsToNoRecommendation')
    }
  }
}
</script>

<style src="./chat-tab.scss" />
